import React, { useEffect, useState } from 'react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import Select, { ISelectValueType } from '../Select/Select';
import { getCountryOptions } from 'src/services/countries';
import classNames from 'classnames';
import { isMessageDescriptor } from '../helpers';

interface ICountrySelectorProps {
    fieldName: string;
    label?: MessageDescriptor | string;
    defaultValue?: string;
    labelClassName?: string;
    className?: string;
    id?: string;
    disabled?: boolean;
    onChange?: (value: string, field: string) => void;
}

const CountrySelect: React.FunctionComponent<ICountrySelectorProps> = ({ fieldName, label, labelClassName, className, id, defaultValue, disabled, onChange }) => {
    const { locale } = useIntl();
    const countryOptions: ISelectValueType[] = getCountryOptions(locale);
    const [isFocused, setIsFocused] = useState(false);

    const defaultSelected = countryOptions.find(c => c.label?.toUpperCase() === defaultValue?.toUpperCase() || c.value?.toString().toUpperCase() === defaultValue?.toUpperCase())

    const [selectedCountry, setSelectedCountry] = useState(defaultSelected?.value)

    useEffect(() => {
        setSelectedCountry(defaultSelected?.value);
    }, [defaultValue, defaultSelected])

    const handleChange = (value: string) => {
        setSelectedCountry(value);
        onChange?.(value, fieldName);
        setIsFocused(true);
    }

    return (
        <>
            <div className={classNames('text-input', className)}>
                {label &&
                    <label
                        className={classNames(
                            'text-input__label',
                            { 'text-input__label--shrunk': defaultValue || isFocused },
                            labelClassName
                        )}
                        htmlFor={id}
                    >
                        {isMessageDescriptor(label)
                            ? <FormattedMessage {...label} />
                            : label
                        }
                    </label>
                }
                <Select
                    values={countryOptions}
                    value={selectedCountry}
                    onChange={handleChange}
                    id={id}
                    disabled={disabled}
                />
            </div>
        </>
    );
};

export default CountrySelect;